export const NOTIFICATION_LEVELS = ['gray', 'yellow', 'red'] as const;

export type NotificationLevel = (typeof NOTIFICATION_LEVELS)[number];

export interface NotificationThresholdFormState {
    enabled: boolean;
    numberOfEvents: string | null;
}

export type NotificationThresholds = Record<NotificationLevel, NotificationThresholdFormState>;
